module.exports = __webpack_public_path__ + "static/13-e13a7b5d8a8b2485affa232831b37be2.png";